import { useDebouncedCallback } from '@/lib/use-debounced-callback';
import { TextField } from '@pms-digital/design-system';
import { useEffect, useRef, useState } from 'react';

/** Keystrokes reach the URL (and the filter) after this pause. */
export const NOTES_SEARCH_DEBOUNCE_MS = 200;

export interface NotesSearchInputProps {
  /** The query held in the URL. */
  value: string;
  onChange: (value: string) => void;
}

/**
 * « Rechercher dans les notes » (planche 12). Typing is local and pushed to the
 * URL after a short pause, so each keystroke does not become a navigation; a
 * change that comes from elsewhere (« Réinitialiser les filtres ») is taken
 * back in.
 */
export function NotesSearchInput({ value, onChange }: NotesSearchInputProps) {
  const [text, setText] = useState(value);
  const lastSent = useRef(value);
  const push = useDebouncedCallback((next: string) => {
    lastSent.current = next;
    onChange(next);
  }, NOTES_SEARCH_DEBOUNCE_MS);

  useEffect(() => {
    if (value === lastSent.current) return;
    lastSent.current = value;
    setText(value);
  }, [value]);

  return (
    <div className="w-[220px]">
      <TextField
        type="search"
        label="Rechercher dans les notes"
        hideLabel
        compact
        icon="search"
        placeholder="Rechercher dans les notes"
        value={text}
        onChange={(event) => {
          setText(event.target.value);
          push(event.target.value);
        }}
      />
    </div>
  );
}
